module.exports = __webpack_public_path__ + "8d15de04f5f6e8e89cab4e5eb237f607.svg";